<template>
  <div class="mb-5">
    <div class="card  mb-4">
      <div class="card-body">
        <template v-if="currentWorkspace && isWorkspaceAdmin">
          <h2 class="text-center">{{ $t("workspace.name-enter") }}</h2>
          <br />

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            inputClass="mb-3"
            :placeholder="$t('workspace.name')"
          />

          <sweet-button buttonClass="btn-block" :disabled="$v.form.$invalid" @click="update()" :loading="isUpdating" variant="success" icon="mdi mdi-check-bold" size="sm">
            {{ $t("common.save") }}
          </sweet-button>

          <hr />
          <sweet-button buttonClass="btn-block mb-2" v-b-modal="'workspace-duplicate-option-modal' + currentWorkspace._id" variant="light" icon="bx bx-copy" size="sm">
            {{ $t("common.duplicate") }}
          </sweet-button>

          <sweet-button buttonClass="btn-block mb-2" v-b-modal="'workspace-delete-option-modal' + currentWorkspace._id" variant="danger" icon="bx bx-trash" size="sm">
            {{ $t("common.delete") }}
          </sweet-button>

          <WorkspaceDeleteOptionModal :id="'workspace-delete-option-modal' + currentWorkspace._id" :workspace="currentWorkspace" @onSuccess="() => reload()" />
          <WorkspaceDuplicateOptionModal
            :id="'workspace-duplicate-option-modal' + currentWorkspace._id"
            :workspace="currentWorkspace"
            @onSuccess="() => reload()"
          ></WorkspaceDuplicateOptionModal>
        </template>

        <!-- <sweet-button buttonClass="btn-block mb-2" variant="primary" icon="bx bx-plus" size="sm" @click="$router.push('/workspace/create')">
          {{ $t("workspace.create-a-new-workspace") }}
        </sweet-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import WorkspaceDeleteOptionModal from "./workspace-delete-option-modal";
import WorkspaceDuplicateOptionModal from "./workspace-duplicate-option-modal";
import WorkspaceInviteMember from "./workspace-invite-member";
export default {
  components: {
    WorkspaceInviteMember,
    WorkspaceDeleteOptionModal,
    WorkspaceDuplicateOptionModal,
  },

  data() {
    return {
      editMode: false,
      title: undefined,
      form: { name: undefined, _id: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(30),
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters[`workspace/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`workspace/isEditMode`];
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.editedEntity };
      },
    },
  },
  mounted() {
    if (this.currentWorkspace) {
      this.$store.commit(`workspace/editedEntity`, this.currentWorkspace);
    }
  },
  methods: {
    async update() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("workspace/updateName", { workspace: this.form });
        this.title = this.form.name;
        this.editMode = false;
        this.$root.$emit("bv::toggle::collapse", "sidebar-workspace-edit");
        this.$toast.success(this.$t("common.success"));
        this.reload();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    reload() {
      window.location.href = "/workspace";
    },
    anyError(e) {
      this.formError = e;
    },
  },
};
</script>
